<!-- 微博广告主下拉 -->
<template>
<a-select
	mode="multiple" 
	style="min-width: 200px;max-width: 600px;"
	placeholder="请选择广告账户"
	:filter-option="false"
	@change="handleChangeB"
	:getPopupContainer="getsPopupContainer" 
	@popupScroll="popupScrollHandle" 
	showSearch
	allowClear
	@search="selectZhSearch"
	:not-found-content="s_fetching ? undefined : null" 
	@blur="zhBlur"
	:value="r_adv_id"
  >
	<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
	<a-select-option v-for="(item,index) in selectGgData" :key="item.adv_id" :value="item.adv_id" :title="item.adv_name">
	  {{item.adv_name}}
	</a-select-option>
	<a-select-option v-if="loading_more_hint" value="-0-">
		<div style="color:rgb(98, 168, 234)">加载更多中...</div>
		
	</a-select-option>
</a-select>
</template>

<script>
import { WbAdvSelect } from '@/request/api'
export default {
	name: 'wbAdvSelect_',
	data() {
		return {
			selectGgData: [], // 选择广告账户
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			blurGgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_adv_id: [],
		}
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		getSelectData(a_id){
			let that = this
			WbAdvSelect({
				page: that.s_page,
				limit: that.s_limit,
			}).then(res=>{
				console.log("获取微博广告账户下拉");
				that.selectGgData = res.data.data.data || []
				that.blurGgData = res.data.data.data || []
			})
		},
		setValue(value){
			console.log("setValue",value);
			let arr = []
			arr.push(value)
			this.r_adv_id = arr
		},
		handleChangeB(e){ // 选择广告账户
			console.log(e);
			this.r_adv_id = e
			this.$emit('handle-change',e)
		},
		popupScrollHandle(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					WbAdvSelect({
						page: that.s_page,
						limit: that.s_limit,
						adv_name: that.s_adv_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectGgData 
						that.loading_more_hint = false
						that.selectGgData = data.concat(res.data.data.data) 
						that.s_fetching = false
						
						// 当先获取到的数据小于总数时，就允许继续下滑加载
						if(that.selectGgData.length < res.data.data.total){
							that.loading_more_control = true
						}
						
					})
				}
				
				
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectGgData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			WbAdvSelect({
				page: 1,
				limit: that.s_limit,
				adv_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.selectGgData = res.data.data.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.selectGgData = that.blurGgData 
			
			that.loading_more_control = true
		},
	},
	
}
</script>

<style>
</style>